export default __webpack_public_path__ + "static/media/multi-select.cc169314.svg";